


import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_LEAVE_TYPES_REQUEST = "FETCH_LEAVE_TYPES_REQUEST";
export const FETCH_LEAVE_TYPES_SUCCESS = "FETCH_LEAVE_TYPES_SUCCESS";
export const FETCH_LEAVE_TYPES_FAILURE = "FETCH_LEAVE_TYPES_FAILURE";

export const CREATE_LEAVE_TYPE_REQUEST = "CREATE_LEAVE_TYPE_REQUEST";
export const CREATE_LEAVE_TYPE_SUCCESS = "CREATE_LEAVE_TYPE_SUCCESS";
export const CREATE_LEAVE_TYPE_FAILURE = "CREATE_LEAVE_TYPE_FAILURE";

export const FETCH_LEAVE_TYPES_MASTER_REQUEST = "FETCH_LEAVE_TYPES_MASTER_REQUEST";
export const FETCH_LEAVE_TYPES_MASTER_SUCCESS = "FETCH_LEAVE_TYPES_MASTER_SUCCESS";
export const FETCH_LEAVE_TYPES_MASTER_FAILURE = "FETCH_LEAVE_TYPES_MASTER_FAILURE";

export const CREATE_LEAVE_TYPE_MASTER_REQUEST = "CREATE_LEAVE_TYPE_MASTER_REQUEST";
export const CREATE_LEAVE_TYPE_MASTER_SUCCESS = "CREATE_LEAVE_TYPE_MASTER_SUCCESS";
export const CREATE_LEAVE_TYPE_MASTER_FAILURE = "CREATE_LEAVE_TYPE_MASTER_FAILURE";


export const UPDATE_LEAVE_TYPE_REQUEST = "UPDATE_LEAVE_TYPE_REQUEST";
export const UPDATE_LEAVE_TYPE_SUCCESS = "UPDATE_LEAVE_TYPE_SUCCESS";
export const UPDATE_LEAVE_TYPE_FAILURE = "UPDATE_LEAVE_TYPE_FAILURE";

// Action Creators
export const fetchLeaveTypesRequest = () => ({ type: FETCH_LEAVE_TYPES_REQUEST });
export const fetchLeaveTypesSuccess = (data) => ({ type: FETCH_LEAVE_TYPES_SUCCESS, payload: data });
export const fetchLeaveTypesFailure = (error) => ({ type: FETCH_LEAVE_TYPES_FAILURE, payload: error });

export const createLeaveTypeRequest = () => ({ type: CREATE_LEAVE_TYPE_REQUEST });
export const createLeaveTypeSuccess = (data) => ({ type: CREATE_LEAVE_TYPE_SUCCESS, payload: data });
export const createLeaveTypeFailure = (error) => ({ type: CREATE_LEAVE_TYPE_FAILURE, payload: error });

export const fetchLeaveTypesMasterRequest = () => ({ type: FETCH_LEAVE_TYPES_MASTER_REQUEST });
export const fetchLeaveTypesMasterSuccess = (data) => ({ type: FETCH_LEAVE_TYPES_MASTER_SUCCESS, payload: data });
export const fetchLeaveTypesMasterFailure = (error) => ({ type: FETCH_LEAVE_TYPES_MASTER_FAILURE, payload: error });

export const createLeaveTypeMasterRequest = () => ({ type: CREATE_LEAVE_TYPE_MASTER_REQUEST });
export const createLeaveTypeMasterSuccess = (data) => ({ type: CREATE_LEAVE_TYPE_MASTER_SUCCESS, payload: data });
export const createLeaveTypeMasterFailure = (error) => ({ type: CREATE_LEAVE_TYPE_MASTER_FAILURE, payload: error });

export const UPDATE_LEAVE_TYPE_ADMIN_REQUEST = "UPDATE_LEAVE_TYPE_ADMIN_REQUEST";
export const UPDATE_LEAVE_TYPE_ADMIN_SUCCESS = "UPDATE_LEAVE_TYPE_ADMIN_SUCCESS";
export const UPDATE_LEAVE_TYPE_ADMIN_FAILURE = "UPDATE_LEAVE_TYPE_ADMIN_FAILURE";


// Thunk: Fetch All Leave Types (Admin)
export const fetchLeaveTypes = () => {
  return async (dispatch) => {
    dispatch(fetchLeaveTypesRequest());
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${BASE_URL}/v1/api/get_leave_typesAdmin`, {
        headers: { authorization: token },
      });
      dispatch(fetchLeaveTypesSuccess(res.data.data));
    } catch (err) {
      const errorMsg = err?.response?.data?.meta?.message || err.message;
      dispatch(fetchLeaveTypesFailure(errorMsg));
    }
  };
};

// Thunk: Fetch Master Leave Types
export const fetchLeaveTypesMaster = () => {
  return async (dispatch) => {
    dispatch(fetchLeaveTypesMasterRequest());
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${BASE_URL}/v1/api/get_leave_types_master`, {
        headers: { authorization: token },
      });
      dispatch(fetchLeaveTypesMasterSuccess(res.data.data));
    } catch (err) {
      const errorMsg = err?.response?.data?.meta?.message || err.message;
      dispatch(fetchLeaveTypesMasterFailure(errorMsg));
    }
  };
};

// Thunk: Create Master Leave Type
export const createLeaveTypeMaster = (name, description) => {
  return async (dispatch) => {
    dispatch(createLeaveTypeMasterRequest());
    const token = localStorage.getItem("token");

    try {
      const res = await axios.post(
        `${BASE_URL}/v1/api/create_leave_type_master`,
        { name, description },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );
      dispatch(createLeaveTypeMasterSuccess(res.data.data));
      toast.success("Leave type master created successfully!");
    } catch (err) {
      const errorMsg = err?.response?.data?.meta?.message || err.message;
      dispatch(createLeaveTypeMasterFailure(errorMsg));
      toast.error(errorMsg);
    }
  };
};

// Thunk: Create Leave Type + Policy
export const createLeaveType = (name, description, policies) => {
  return async (dispatch) => {
    dispatch(createLeaveTypeRequest());
    const token = localStorage.getItem("token");

    try {
      const res = await axios.post(
        `${BASE_URL}/v1/api/create_leave_type`,
        { name, description, policy: policies },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );
      dispatch(createLeaveTypeSuccess(res.data));
      toast.success("Leave type created successfully!");
    } catch (err) {
      const errorMsg = err?.response?.data?.meta?.message || err.message;
      dispatch(createLeaveTypeFailure(errorMsg));
      toast.error(errorMsg);
    }
  };
};

// Thunk: Update Leave Type Policy by ID
export const updateLeaveTypePolicy = (id, description, policies) => {
  return async (dispatch) => {
    dispatch(createLeaveTypeRequest());
    const token = localStorage.getItem("token");

    try {
      const res = await axios.post(
        `${BASE_URL}/v1/api/update_leave_policy_by_type`,
        { id, description, policy: policies },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );
      dispatch(createLeaveTypeSuccess(res.data));
      toast.success("Leave type policy updated successfully!");
    } catch (err) {
      const errorMsg = err?.response?.data?.meta?.message || err.message;
      dispatch(createLeaveTypeFailure(errorMsg));
      toast.error(errorMsg);
    }
  };
};


export const updateLeaveTypeAdmin = (id, name, description, status, policies) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_LEAVE_TYPE_ADMIN_REQUEST });
    const token = localStorage.getItem("token");

    try {
      const res = await axios.post(
        `${BASE_URL}/v1/api/update_leave_typeAdmin`,
        {
          id,
          name,
          description,
          status,
          policies
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );

      dispatch({ type: UPDATE_LEAVE_TYPE_ADMIN_SUCCESS, payload: res.data });
      toast.success("Leave type (Admin) updated successfully!");
    } catch (err) {
      const errorMsg = err?.response?.data?.meta?.message || err.message;
      dispatch({ type: UPDATE_LEAVE_TYPE_ADMIN_FAILURE, payload: errorMsg });
      toast.error(errorMsg);
    }
  };
};

export const assignLeaveTypesToUser = (userId, leaveTypeIds) => async (dispatch) => {
  try {
    await axios.post(
     
       `${BASE_URL}/v1/api/assign_leave_types_to_user`,
      { user_id: userId, leave_type_ids: leaveTypeIds },
      {
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("token"), // or your auth logic
        },
      }
    );
    //toast.success("Leave types assigned successfully!");
    // Optionally re-fetch users
  } catch (error) {
    console.error("Error assigning leave types:", error);
    toast.error("Failed to assign leave types");
  }
};